<template>
  <section :class="$style.container">
    <h1>Notes</h1>
    <activity-notes :focus="true" :class="$style.activityNotes" />
  </section>
</template>

<script>
import { createNamespacedHelpers } from 'vuex'
import ActivityNotes from 'vue-components/activity-notes/components/activity-notes'

const { mapMutations } = createNamespacedHelpers('activityNotes')

export default {
  components: {
    ActivityNotes
  },
  props: [
    'activity'
  ],
  watch: {
    activity: {
      immediate: true,
      handler (activity) {
        this.setActivity(activity)
      }
    }
  },
  methods: {
    ...mapMutations([
      'setActivity'
    ])
  }
}
</script>

<style module lang="less" src="./notepad.less"></style>



// WEBPACK FOOTER //
// notepad.vue?1af8f50a